module.exports = "<div class=\"kan-partner-type-list\">\n    <kan-partner-type-list-item *ngFor=\"let partnerType of partnerTypes\"\n                           [partnerType]=\"partnerType\"\n                           (refresh)=\"emitRefresh()\">\n    </kan-partner-type-list-item>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/partner-type/list/component.html
// module id = ./src/modules/admin/components/partner-type/list/component.html
// module chunks = main